import Tier0 from './Tier0';
import Tier1 from './Tier1';
import Tier2 from './Tier2';
import { SliderTab } from '@silverfort/sf-components';
import { Dispatch, useEffect, useMemo, useState } from 'react';
import { TIER0, TIER1, TIER2 } from '../PASReducer';
import { TierResourcesProvider, useTierResourcesContext } from './TierResourcesContext';
import { TIER_SCOPES } from './Tier/TierConsts';
import { TIER_FIELDS } from '../../../common/fields';

const { TIER } = TIER_FIELDS;

export type AssetsParams = {
    tiersConfig: {
        [key: string]: {
            id: string;
            name: string;
            tooltip: string;
            fields: {
                [key: string]: any;
            };
            validators: {
                [key: string]: any;
            };
        };
    };
    settings: Object;
    dispatch: Dispatch<{ type: string; payload: any }>;
    save: Function;
};

export const Assets = ({ tiersConfig, settings, dispatch, save }: AssetsParams) => {
    return (
        <>
            <TierResourcesProvider>
                <AssetsInner tiersConfig={tiersConfig} settings={settings} dispatch={dispatch} save={save} />
            </TierResourcesProvider>
        </>
    );
};

const AssetsInner = ({ tiersConfig, settings, dispatch, save }: AssetsParams) => {
    const { setTiersResources } = useTierResourcesContext();
    useEffect(() => {
        const tier0Config = tiersConfig[TIER0.ID].fields[TIER.ID].value[TIER_SCOPES.IN_SCOPE];
        const tier1Config = tiersConfig[TIER1.ID].fields[TIER.ID].value[TIER_SCOPES.IN_SCOPE];
        const tier2Config = tiersConfig[TIER2.ID].fields[TIER.ID].value[TIER_SCOPES.IN_SCOPE];

        const tier0Resources = [
            ...Object.keys(tier0Config.servers),
            ...Object.keys(tier0Config.groups),
            ...Object.keys(tier0Config.ous)
        ];
        const tier1Resources = [
            ...Object.keys(tier1Config.servers),
            ...Object.keys(tier1Config.groups),
            ...Object.keys(tier1Config.ous)
        ];
        const tier2Resources = [
            ...Object.keys(tier2Config.servers),
            ...Object.keys(tier2Config.groups),
            ...Object.keys(tier2Config.ous)
        ];
        setTiersResources(new Set([...tier0Resources, ...tier1Resources, ...tier2Resources]));
    }, [setTiersResources, tiersConfig]);

    const [selectedTier, setSelectedTier] = useState(tiersConfig[TIER0.ID]?.id);
    const sliderItems = [TIER0, TIER1, TIER2].map((tier) => ({
        id: tier.ID,
        label: tier.NAME
    }));

    const tierContent = useMemo(() => {
        if (tiersConfig[TIER0.ID] && selectedTier === TIER0.ID) {
            return <Tier0 settings={settings} fields={tiersConfig[TIER0.ID].fields} dispatch={dispatch} save={save} />;
        }
        if (tiersConfig[TIER1.ID] && selectedTier === TIER1.ID) {
            return <Tier1 fields={tiersConfig[TIER1.ID].fields} dispatch={dispatch} save={save} />;
        }
        if (tiersConfig[TIER2.ID] && selectedTier === TIER2.ID) {
            return <Tier2 fields={tiersConfig[TIER2.ID].fields} dispatch={dispatch} save={save} />;
        }
    }, [tiersConfig, save, selectedTier]);

    return (
        <>
            <SliderTab items={sliderItems} selectedId={selectedTier} onSelect={setSelectedTier} />
            {tierContent}
        </>
    );
};
